var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.5 16H6.5C4.843 16 3.5 14.657 3.5 13V6C3.5 4.343 4.843 3 6.5 3H18.5C20.157 3 21.5 4.343 21.5 6V13C21.5 14.657 20.157 16 18.5 16Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C8.38071 7 9.5 5.88071 9.5 4.5C9.5 3.11929 8.38071 2 7 2C5.61929 2 4.5 3.11929 4.5 4.5C4.5 5.88071 5.61929 7 7 7Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.429 8H5.5C4.395 8 3.5 8.895 3.5 10V20.89C3.5 21.438 3.894 21.935 4.44 21.993C5.027 22.056 5.541 21.633 5.605 21.06L6.131 16.33C6.151 16.143 6.31 16 6.5 16C6.69 16 6.849 16.143 6.87 16.331L7.39 21.013C7.448 21.533 7.858 21.967 8.38 21.998C8.993 22.034 9.5 21.549 9.5 20.945V11.309C9.5 11.05 9.691 10.83 9.947 10.793L14.531 10.138C15.049 10.064 15.473 9.646 15.498 9.124C15.528 8.508 15.038 8 14.429 8Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1533 16L15.8423 21.068C16.0283 21.625 16.5493 22 17.1363 22C18.0663 22 18.7243 21.088 18.4293 20.206L17.0273 16H14.1533Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlides);
export default __webpack_public_path__ + "static/media/slides.8bf9dc2ad6b0444a5ce0474b7611fc01.svg";
export { ForwardRef as ReactComponent };